module.exports = __webpack_public_path__ + "static/media/003-invoice.03a6ca4c.svg";